/** Number of distinct presence colors defined in global.css. */
export const PALETTE_SIZE = 8;
